import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faCancel } from '@fortawesome/free-solid-svg-icons';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { LoanFile } from '../constants/loanFile';

interface RemoveFileButtonProps {
    id: string;
    file: LoanFile;
    onRemove: () => void;
    /** Takes back a saved file's removal. */
    onRestore: () => void;
}

/**
 * Removes a file, or takes back the removal of one marked "To be deleted". A saved file can only be removed when its
 * canDelete allows it; a new one always can.
 */
export const RemoveFileButton = ({ id, file, onRemove, onRestore }: RemoveFileButtonProps) => {
    if (file.isDeleted) {
        return (
            <IconButton
                id={id}
                theme={IconButtonTheme.Transparent}
                size={IconButtonSize.ExtraSmall}
                icon={faCancel}
                hint='Cancel Delete'
                handleClick={onRestore}
            />
        );
    }

    return (
        <IconButton
            id={id}
            theme={IconButtonTheme.TransparentRed}
            size={IconButtonSize.ExtraSmall}
            icon={faTrashCan}
            hint='Remove File'
            disabled={file.id !== 0 && !file.canDelete}
            handleClick={onRemove}
        />
    );
};
